// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IgE_","option":"styles_option__ZDipA","active":"styles_active__2E25O"};